import { defineMessages } from 'react-intl';

export default defineMessages({
    whereDidThisHappen: {
        id: 'fnol.wc.directives.loss-location.Loss/Incident Location',
        defaultMessage: 'Loss/Incident Location'
    },
    fnolUseMyPolicyAddress: {
        id: 'fnol.wc.directives.loss-location.Use my policy address',
        defaultMessage: 'Use my policy address'
    },
    fnolSpecifyFullAddress: {
        id: 'fnol.wc.directives.loss-location.Specify full address manually',
        defaultMessage: 'Specify full address manually'
    },
    fnolKnowCity: {
        id: 'fnol.wc.directives.loss-location.I just know the city',
        defaultMessage: 'I just know the city'
    },
    fnolLocationMap: {
        id: 'fnol.wc.directives.loss-location.Choose location on a map',
        defaultMessage: 'Choose location on a map'
    },
    fnolSelectAddress: {
        id: 'fnol.wc.directives.loss-location.Select Address',
        defaultMessage: 'Select Address'
    },
    fnolChooseAddress: {
        id: 'fnol.wc.directives.loss-location.-- Choose Address --',
        defaultMessage: '-- Choose Address --'
    },
    fnolProvideAddress: {
        id: 'fnol.wc.directives.loss-location.Please provide an address.',
        defaultMessage: 'Please provide an address.'
    },
    fnolMapLocation: {
        id: 'fnol.wc.directives.loss-location.Click anywhere on the map to set a location or drag the pin to adjust it.',
        defaultMessage: 'Click anywhere on the map to set a location or drag the pin to adjust it.'
    },
    fnolProvince: {
        id: 'fnol.wc.directives.loss-location.Province',
        defaultMessage: 'Province'
    },
    fnolPostalCode: {
        id: 'fnol.wc.directives.loss-location.Postal Code',
        defaultMessage: 'Postal Code'
    },
    fnolState: {
        id: 'fnol.wc.directives.loss-location.State',
        defaultMessage: 'State'
    },
    fnolZipCode: {
        id: 'fnol.wc.directives.loss-location.ZIP Code',
        defaultMessage: 'ZIP Code'
    }
});
